// @ts-nocheck
document.addEventListener("DOMContentLoaded", () => {
  if (!customElements.get("bed-builder")) {
    class BedBuilder extends HTMLElement {
      selection = {
        "fitted-sheet": null,
        "flat-sheet": null,
        quilt: null,
        "standard-pillow": null,
        "king-pillow": null,
        "euro-pillow": null,
      };
      groups = {
        sheets: ["fitted-sheet", "flat-sheet", "quilt"],
        pillows: ["standard-pillow", "king-pillow", "euro-pillow"],
      };
      constructor() {
        super();
        this.iFrameElement = this.querySelector(".content-frame");
        this.builderFormItems = this.querySelector("[data-builder-form-items]");
        this.addToCart = this.querySelector("[data-add-to-cart]");
        this.resetBtn = this.querySelector("[data-reset-btn]");
        this.loader = this.querySelector("[data-loader]");
        //We have 2 components groups, sheets and pillows.
        this.builderComponentsGroup = this.querySelectorAll(
          "[data-builder-components-group]"
        );
        this.builderComponentOptions = this.querySelectorAll(
          "[data-builder-component-option]"
        );
        this.builderComponentSizeCheckboxes = this.querySelectorAll(
          "[data-builder-component-size]"
        );
        this.builderTotal = this.querySelector("[data-builder-total]");
        this.builderSelection = this.querySelector(
          "[data-builder-selection-list]"
        );
        this.btnShareOnPinterest = this.querySelector(
          "[data-share-on-pinterest]"
        );
        this.btnCopyLink = this.querySelector("[data-copy-link]");
        this.btnShareViaEmail = this.querySelector("[data-share-via-email]");
        this.btnSharer = this.querySelector("[data-sharer]");
        this.socialTitle = this.btnSharer?.dataset?.sharerTitle;
        this.socialImage = this.btnSharer?.dataset?.sharerImage;
        this.socialDescription = this.btnSharer?.dataset?.sharerDescription;
        this.form = this.querySelector("form");
        this.initialized = false;

        // @ts-ignore
        iFrameResize(
          {
            log: false,
            onMessage: ({ message }) => {
              if (message.action && message.action === "READY") {
                if (!this.initialized) {
                  this.init();
                  this.initializeFromUrl();
                  this.initialized = true;
                } else {
                  this.setLoading(false);
                }
              }
            },
          },
          this.iFrameElement
        );

        this.init = this.init.bind(this);
        this.initializeFromUrl = this.initializeFromUrl.bind(this);
        this.selectComponentOption = this.selectComponentOption.bind(this);
        this.updateSelection = this.updateSelection.bind(this);
        this.showComponentTab = this.showComponentTab.bind(this);
        this.toggleLoader = this.toggleLoader.bind(this);
        this.setLoading = this.setLoading.bind(this);
        this.copyLink = this.copyLink.bind(this);
        this.shareOnPinterest = this.shareOnPinterest.bind(this);
        this.setLoading(true);
      }

      isMobile() {
        // Use the modern User-Agent Client Hints API if available
        if (navigator.userAgentData) {
          // userAgentData.mobile is a boolean indicating mobile devices
          return navigator.userAgentData.mobile;
        }

        // Fallback to checking userAgent string
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        );
      }

      connectedCallback() {}

      setLoading(state) {
        this.loading = state;
        this.toggleLoader();
      }

      shareOnPinterest(e) {
        const pinterestURL = `https://pinterest.com/pin/create/button/?media=${this.socialImage}&url=${window.location.href}&description=${this.socialTitle}`;
        window.open(pinterestURL, "_blank");
      }

      async copyLink(e) {
        // Get the current URL
        const title = this.socialTitle;
        const imageSrc = this.socialImage;
        const currentURL = window.location.href;
        const tooltip = e.target.querySelector("[data-tooltip]");

        if ((navigator.share || "canShare" in window.navigator) && this.isMobile()) {
          let dataWithFiles = null;
          let files = null;
          if (imageSrc) {
            const ext = imageSrc.split(".").pop();
            const blob = await fetch(imageSrc).then((res) => res.blob());
            files = [
              new File([blob], `share-story-${Date.now()}.${ext}`, {
                type: blob.type,
                lastModified: new Date().getTime(),
              }),
            ];
            dataWithFiles = {
              files: files,
              title: title,
              url: window.location.href,
            };
          }
          const data = {
            title: title || "",
            url: window.location.href,
          };
          if (
            "canShare" in window.navigator &&
            dataWithFiles &&
            window.navigator.canShare(dataWithFiles)
          ) {
            navigator
              .share(dataWithFiles)
              .then(() => console.info("Successful share"))
              .catch((error) => console.error("Error sharing:", error));
          } else if (
            "canShare" in window.navigator &&
            window.navigator.canShare(data)
          ) {
            navigator
              .share(data)
              .then(() => console.info("Successful share"))
              .catch((error) => console.error("Error sharing:", error));
          } else if (dataWithFiles) {
            navigator
              .share(dataWithFiles)
              .then(() => console.info("Successful share"))
              .catch((error) => console.error("Error sharing:", error));
          } else {
            navigator
              .share(data)
              .then(() => console.info("Successful share"))
              .catch((error) => console.error("Error sharing:", error));
          }
        } else {
          // Copy the current URL to the clipboard
          navigator.clipboard
            .writeText(currentURL)
            .then(function () {
              if (tooltip) {
                tooltip.innerHTML = "Copied";
                tooltip.classList.add("show");
              }
              setTimeout(() => {
                tooltip?.classList.remove("show");
              }, 1000);
            })
            .catch(function (error) {
              console.error("Unable to copy URL to clipboard: ", error);
            });
        }
      }

      toggleLoader() {
        if (this.loader) {
          if (this.loading) {
            this.loader.classList.add("loading");
          } else {
            this.loader.classList.remove("loading");
          }
        }
      }

      init() {
        this.btnShareOnPinterest?.addEventListener("click", (e) => {
          this.shareOnPinterest();
        });
        this.btnCopyLink.addEventListener("click", (e) => {
          this.copyLink(e);
        });
        this.btnShareViaEmail.addEventListener("click", (e) => {
          const url = `mailto:?subject=${encodeURIComponent(
            this.socialTitle
          )}&body=${encodeURIComponent(
            `${this.socialDescription}\n\n${window.location.href}`
          )}`;
          window.open(url);
        });
        this.form.addEventListener("submit", (e) => {
          e.preventDefault();
          const toAdd = [];
          Object.keys(this.selection).map((component) => {
            if (this.selection[component]) {
              toAdd.push({
                id: this.selection[component].variantId,
                quantity: 1,
              });
            }
          });
          if (toAdd.length > 0) {
            this.addToCart.classList.add("btn--loading");
            fetch(theme.routes.cartAdd, {
              method: "POST",
              body: JSON.stringify({ items: toAdd }),
              credentials: "same-origin",
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "X-Requested-With": "XMLHttpRequest",
              },
            })
              .then((response) => response.json())
              .then(
                function (data) {
                  if (data.status === 422) {
                    this.error(data);
                  } else {
                    const product = data;
                    document.dispatchEvent(
                      new CustomEvent("ajaxProduct:added", {
                        detail: {
                          product: product,
                          addToCartBtn: this.addToCart,
                        },
                      })
                    );
                    this.resetBuilder();
                  }

                  // status.loading = false;
                  this.addToCart.classList.remove("btn--loading");
                }.bind(this)
              );
          } else {
            alert("Choose options");
          }
        });

        this.resetBtn.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.resetBuilder();
          return false;
        });

        if (this.builderComponentsGroup.length > 0) {
          [...this.builderComponentsGroup].map((componentsGroup) => {
            let builderTabs =
              componentsGroup.querySelectorAll("[data-builder-tab]");
            if (builderTabs.length > 0) {
              [...builderTabs].map((tab) => {
                tab.addEventListener("click", (e) => {
                  e.preventDefault();
                  const component = tab.dataset.builderTab;
                  const id = tab.hash.replace("#", "");
                  this.showComponentTab(component);
                  this.showSizeChart(componentsGroup, component);
                });
              });
            }
          });
        }

        //Events when a size is selected
        if (this.builderComponentSizeCheckboxes.length > 0) {
          [...this.builderComponentSizeCheckboxes].map((checkbox) => {
            checkbox.addEventListener("change", () => {
              const component = checkbox.dataset.builderComponentSize;
              if (this.selection[component]) {
                const fabric = this.selection[component].fabric;
                const size = checkbox.value;
                this.selectComponentOption(component, size, fabric);
              }
            });
          });
        }

        //Events when a fabric is selected
        if (this.builderComponentOptions) {
          [...this.builderComponentOptions].map((option) => {
            option.addEventListener("click", (e) => {
              const element = e.target;
              if (element) {
                const component = element.dataset.builderComponent;
                const size = element.dataset.size || null;
                const fabric = element.dataset.fabric;
                this.selectComponentOption(component, size, fabric);
              }
            });
          });
        }
      }

      resetBuilder() {
        const threeDComponents = [];
        Object.keys(this.selection).map((component) => {
          if (this.selection[component]) {
            threeDComponents.push({
              action: "REMOVE",
              target: component === "quilt" ? "duvet" : component,
              value: this.selection[component].fabric,
            });
          }
          this.selection[component] = null;
        });
        if (threeDComponents.length > 0 && this.iFrameElement) {
          this.iFrameElement.iFrameResizer.sendMessage(threeDComponents);
        }
        this.updateSelection();

        const tabGroups = this.querySelectorAll("[data-builder-tabs]");
        [...tabGroups].map((tabGroup) => {
          const tabs = tabGroup.querySelectorAll("[data-builder-tab]");
          this.showComponentTab([...tabs][0].dataset.builderTab);
          [...tabs].map((tab) => {
            const component = tab.dataset.builderTab;
            if (component) {
              const allCheckboxes = this.querySelectorAll(
                `[data-builder-component-size="${component}"]`
              );
              if (allCheckboxes.length > 0) {
                const size = [...allCheckboxes][0].value;
                if (size) {
                  this.activateSize(component, size);
                }
              }
            }
          });
        });
        this.updateTotals();
        window.scroll({
          top: 0,
          behavior: "smooth",
        });
      }

      updateSelection() {
        Object.keys(this.selection).map((component) => {
          const componentTab = this.querySelector(
            `[data-builder-tab="${component}"]`
          );
          let allFabricOptions = this.querySelectorAll(
            `[data-builder-component-option][data-builder-component="${component}"][data-fabric]`
          );
          if (this.selection[component]) {
            //Show the tick icon on component tab
            componentTab?.classList.add("selected");
            //For components with size we display the size colour options
            const size = this.selection[component].size;
            const fabric = this.selection[component].fabric;
            let currentFabricOption;
            if (size) {
              currentFabricOption = this.querySelector(
                `[data-builder-component-option][data-builder-component="${component}"][data-size="${size}"][data-fabric="${fabric}"]`
              );

              //Show the fabrics container for the selected size
              const allSizeFabricOptions = this.querySelectorAll(
                `[data-builder-tab-content="${component}"] ul[data-size]`
              );
              [...allSizeFabricOptions].map((sizeFabricOption) => {
                if (sizeFabricOption.dataset.size === size) {
                  sizeFabricOption.style.display = "";
                } else {
                  sizeFabricOption.style.display = "none";
                }
              });
            } else {
              currentFabricOption = this.querySelector(
                `[data-builder-component-option][data-builder-component="${component}"][data-fabric="${fabric}"]`
              );
            }
            //Mark as active the fabric selected
            if (allFabricOptions.length > 0) {
              [...allFabricOptions].map((option) => {
                if (option === currentFabricOption) {
                  option.classList.add("active");
                } else {
                  option.classList.remove("active");
                }
              });
            }
          } else {
            //Remove any active fabric option
            if (allFabricOptions.length > 0) {
              [...allFabricOptions].map((option) => {
                option.classList.remove("active");
              });
            }
            //Remove the tick icon on component tab
            componentTab?.classList.remove("selected");
          }
        });
        this.updateBuilderUrl();
      }

      selectComponentOption(
        component,
        size,
        fabric,
        updateSelection = true,
        updateIframe = true
      ) {
        let action = "SET";
        let option = null;
        let variantId = null;
        let price = null;
        if (component) {
          if (size) {
            //Fitted, Flat and Quilt have size
            option = document.querySelector(
              `[data-builder-component-option][data-builder-component="${component}"][data-size="${size}"][data-fabric="${fabric}"]`
            );
          } else {
            //Standard, King and Euro Pillows don't have size
            option = document.querySelector(
              `[data-builder-component-option][data-builder-component="${component}"][data-fabric="${fabric}"]`
            );
          }

          if (option) {
            variantId = option.dataset.id;
            price = option.dataset.price;
          } else {
            console.error(component, size, fabric);
          }

          if (
            this.selection[component] &&
            this.selection[component].size === size &&
            this.selection[component].fabric === fabric
          ) {
            action = "REMOVE";
            this.selection[component] = null;
          } else {
            this.selection[component] = {
              size,
              fabric,
              variantId,
              price,
            };
          }
          if (updateSelection) {
            this.updateSelection();
          }
          if (updateIframe) {
            this.updateBuilderIframe(action, component, fabric);
          }
          this.updateTotals();
        } else {
          console.error("no component");
        }
      }

      initializeFromUrl() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        let threeDComponents = [];
        Object.keys(this.selection).map((component) => {
          const value = urlParams.get(component);
          if (value) {
            let size, fabric;
            if (value.includes(".")) {
              [size, fabric] = value.split(".");
            } else {
              size = null;
              fabric = value;
            }

            threeDComponents.push({
              action: "SET",
              target: component === "quilt" ? "duvet" : component,
              value: fabric,
            });
            this.selectComponentOption(component, size, fabric, false, false);
            if (size) {
              this.activateSize(component, size);
            }
          }
        });

        if (threeDComponents.length > 0 && this.iFrameElement) {
          this.iFrameElement.iFrameResizer.sendMessage(threeDComponents);
        }
        this.updateSelection();

        let sheetsGroup = false;
        let pillowsGroup = false;
        Object.keys(this.selection).map((component) => {
          if (this.selection[component]) {
            if (
              ["fitted-sheet", "flat-sheet", "quilt"].includes(component) &&
              !sheetsGroup
            ) {
              const tab = document.querySelector(
                `[data-builder-components-group="sheets"] [data-builder-tab-component="${component}"]`
              );
              tab?.click();
              sheetsGroup = true;
              this.showComponentTab(component);
            } else if (
              ["standard-pillow", "king-pillow", "euro-pillow"].includes(
                component
              ) &&
              !pillowsGroup
            ) {
              const tab = document.querySelector(
                `[data-builder-components-group="sheets"] [data-builder-tab-component="${component}"]`
              );
              tab?.click();
              pillowsGroup = true;
              this.showComponentTab(component);
            }
          }
        });
        this.setLoading(false);
      }

      updateTotals() {
        const total =
          Object.keys(this.selection).reduce((acum, item) => {
            if (this.selection[item]) {
              acum = acum + Number(this.selection[item].price);
            }
            return acum;
          }, 0) / 100;

        if (this.builderFormItems) {
          this.builderFormItems.innerHTML = "";
        }
        if (this.builderSelection) {
          this.builderSelection.innerHTML = "";
          let index = 0;
          Object.keys(this.selection).map((component) => {
            if (this.selection[component]) {
              const div = document.createElement("div");
              div.classList.add("builder-totals-item", "grid__item");
              div.innerHTML = `<div class="two-thirds">${component.replace(
                "-",
                " "
              )} ${
                this.selection[component].size
                  ? "- " + this.selection[component].size.toLowerCase()
                  : ""
              } - ${
                this.selection[component].fabric
              }</div><div class="one-third">${(
                this.selection[component].price / 100
              ).toFixed(2)}</div>`;
              this.builderSelection.appendChild(div);
              if (this.builderFormItems) {
                const input = document.createElement("input");
                input.name = `items[${index}]id`;
                index += 1;
                input.value = this.selection[component].variantId;
                input.type = "hidden";
                this.builderFormItems.appendChild(input);
              }
            }
          });
        }
        if (this.builderTotal) {
          this.builderTotal.innerHTML = `$ ${total.toFixed(2)}`;
        }
      }

      updateBuilderIframe(action, component, fabric) {
        if (this.iFrameElement) {
          if (component === "quilt") {
            component = "duvet";
          }
          const message = {
            action,
            target: component,
            value: fabric,
          };
          this.iFrameElement.iFrameResizer.sendMessage(message);
        }
      }

      updateBuilderUrl() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        Object.keys(this.selection).map((component) => {
          if (!this.selection[component]) {
            urlParams.delete(component);
          } else {
            const size = this.selection[component].size;
            const fabric = this.selection[component].fabric;
            urlParams.set(component, `${size ? `${size}.` : ""}${fabric}`);
          }
        });
        const paramsString = urlParams.toString();
        const params = paramsString !== "" ? `?${paramsString}` : "";
        const url =
          window.location.protocol +
          "//" +
          window.location.hostname +
          window.location.pathname +
          params;
        window.history.pushState({ path: url }, "", url);
      }

      showComponentTab(component) {
        const tab = this.querySelector(`[data-builder-tab="${component}"]`);
        const tabContent = this.querySelector(
          `[data-builder-tab-content="${component}"]`
        );
        //Mark the seleted tab as active
        if (tab) {
          const tabSiblings =
            tab.parentElement.parentElement.querySelectorAll(
              "[data-builder-tab]"
            );
          [...tabSiblings].map((tabSibling) => {
            if (tabSibling !== tab) {
              tabSibling.classList.remove("active");
            } else {
              tabSibling.classList.add("active");
            }
          });
        }
        //Display the tab content
        if (tabContent) {
          const tabContentSiblings = tabContent.parentElement.querySelectorAll(
            "[data-builder-tab-content]"
          );
          [...tabContentSiblings].map((tabContentSibling) => {
            if (tabContentSibling !== tabContent) {
              tabContentSibling.style.display = "none";
            } else {
              tabContentSibling.style.display = "";
            }
          });
        }
      }

      activateSize(component, size) {
        const allCheckboxes = this.querySelectorAll(
          `[data-builder-component-size="${component}"]`
        );
        if (allCheckboxes.length > 0) {
          [...allCheckboxes].map((checkbox) => {
            if (checkbox.value !== size) {
              checkbox.removeAttribute("checked");
            } else {
              checkbox.setAttribute("checked", "");
              checkbox.click();
            }
          });
        }
      }

      showSizeFabrics(component, size) {
        const allSizeFabrics = document.querySelectorAll(
          `[data-builder-tab-content="${component}"] ul[data-size]`
        );
        [...allSizeFabrics].map((sizeFabrics) => {
          if (sizeFabrics.dataset.size === size) {
            sizeFabrics.style.display = "";
          } else {
            sizeFabrics.style.display = "none";
          }
        });
      }

      showSizeChart(componentsGroup, component) {
        const allSizeCharts = componentsGroup.querySelectorAll(
          "[data-builder-size-chart]"
        );
        [...allSizeCharts].map((sizeChart) => {
          if (sizeChart.dataset.builderSizeChart === component) {
            sizeChart.style.display = "";
          } else {
            sizeChart.style.display = "none";
          }
        });
      }
    }
    customElements.define("bed-builder", BedBuilder);
  }
});
